import serviceTicketPartsCreateComponent from './service_ticket_parts.create.component';

let serviceTicketPartsCreateModule = angular.module('serviceTicketPartsCreate', [])

    .component('serviceTicketPartsCreate', serviceTicketPartsCreateComponent)

    .name;

export default serviceTicketPartsCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/service_ticket_parts/create/index.js